module.exports = __webpack_public_path__ + "static/media/background.bf239437.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/games/coinRunner/background.png
// module id = 372
// module chunks = 0